import React, {useState} from 'react';
import glossary from './glossary.json';

export function SourceCitation({id, sources}) {
  const index = Number(String(id).replace(/^source-/, ''));
  if (!Number.isInteger(index) || index < 1 || index > sources.length) return <span className="an-missing">missing source</span>;
  return <sup className="an-citation"><a href={`#an-source-${index}`} aria-label={`Open source ${index}`} onClick={() => {
    const panel = document.getElementById('an-sources'); if (panel) panel.open = true;
    requestAnimationFrame(() => document.getElementById(`an-source-${index}`)?.focus());
  }}>{index}</a></sup>;
}
function Term({term, children}) {
  const [open, setOpen] = useState(false);
  return <span className="an-glossary"><button type="button" aria-expanded={open} onClick={() => setOpen(!open)} onKeyDown={event => {if(event.key === 'Escape') setOpen(false);}}>{children}</button>{open && <span className="an-definition" role="note">{glossary[term]}</span>}</span>;
}
const terms = Object.keys(glossary).sort((a,b)=>b.length-a.length);
const pattern = new RegExp(`(\\b(?:${terms.join('|')})\\b)`, 'gi');
function plain(text, seen) {
  return text.split(pattern).map((part,index) => {
    const key = terms.find(term => term.toLowerCase() === part.toLowerCase());
    if (!key || seen.has(key)) return part;
    seen.add(key); return <Term key={index} term={key}>{part}</Term>;
  });
}
export function InlineText({text = '', sources = [], seen = new Set()}) {
  const tokens = String(text).split(/(\[\d+\]|\[[^\]]+\]\([^)]+\)|\*\*[^*]+\*\*|\*[^*]+\*)/g);
  return tokens.map((token,index) => {
    if (/^\[\d+\]$/.test(token)) return <SourceCitation key={index} id={token.slice(1,-1)} sources={sources}/>;
    const link = token.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
    if (link) {
      if (/^source:\/\//.test(link[2])) return <React.Fragment key={index}>{plain(link[1],seen)}<SourceCitation id={link[2].slice(9)} sources={sources}/></React.Fragment>;
      let safe = false; try {safe = ['https:', 'http:'].includes(new URL(link[2]).protocol);} catch {}
      return safe ? <a key={index} href={link[2]} target="_blank" rel="noopener noreferrer">{plain(link[1],seen)}</a> : <React.Fragment key={index}>{plain(link[1],seen)}</React.Fragment>;
    }
    if (token.startsWith('**') && token.endsWith('**')) return <strong key={index}>{plain(token.slice(2,-2),seen)}</strong>;
    if (token.startsWith('*') && token.endsWith('*')) return <em key={index}>{plain(token.slice(1,-1),seen)}</em>;
    return <React.Fragment key={index}>{plain(token,seen)}</React.Fragment>;
  });
}
export default function NewsletterText({text, sources}) {
  const seen = new Set();
  return String(text || '').split(/\n\s*\n/).filter(Boolean).map((block,index) => {
    const rows = block.split('\n');
    if (rows.every(row => /^\s*[-*]\s+/.test(row))) return <ul key={index}>{rows.map((row,i)=><li key={i}><InlineText text={row.replace(/^\s*[-*]\s+/,'')} sources={sources} seen={seen}/></li>)}</ul>;
    const heading = block.match(/^#{1,4}\s+(.+)$/);
    return heading ? <h3 key={index}><InlineText text={heading[1]} sources={sources} seen={seen}/></h3> : <p key={index}><InlineText text={block} sources={sources} seen={seen}/></p>;
  });
}
